<template>
  <div>
    <div>
      <i class="fa fa-clock-o pr-1"></i>
      {{ $options.filters.localTime(event.start, 'HH:mm')}} -
      {{ $options.filters.localTime(event.end, 'HH:mm')}}
    </div>
    <div v-if="event.notes">
      <i class="fa fa-pencil pr-1"></i>
      <span v-text="event.notes"></span>
    </div>
    <div v-if="event.name" className="person-name">
      <i class="fa fa-user pr-1"></i>
      <span v-text="event.name"></span>
    </div>
    <div v-if="event.phone ">
      <i class="fa fa-phone pr-1"></i>
      <span v-text="event.phone"></span>
    </div>
    <div v-if="event.facility">
      <i class="fa fa-map-marker pr-1"></i>
      {{ event.facility.name }} <span v-if="location" v-text="` (${location})`"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  computed: {
    location: function () {
      if (this.event.facility.address && this.event.facility.address.city) {
        return this.event.facility.address.city
      }
      return null
    }
  }
}
</script>
